import { AttachMoneyOutlined, ChatBubbleOutlineOutlined, HeadphonesOutlined, HomeOutlined } from "@mui/icons-material";
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import MonitorOutlinedIcon from '@mui/icons-material/MonitorOutlined';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import LibraryMusicOutlinedIcon from '@mui/icons-material/LibraryMusicOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import { PATHS } from "../../routes";

export const areliaRoutes = [
  {
    id: 0,
    link: PATHS.DASHBOARD,
    label: "Home",
    icon: HomeOutlined,
  },
  {
    id: 1,
    link: PATHS.EARNINGS,
    label: "Earnings",
    icon: AttachMoneyOutlined,
  },
  {
    id: 2,
    link: PATHS.STREAMING,
    label: "Streaming",
    icon: HeadphonesOutlined,
  },
  {
    id: 3,
    link: PATHS.SOCIAL,
    label: "My Social",
    icon: ChatBubbleOutlineOutlined,
  },
  {
    id: 4,
    link: PATHS.FANS,
    label: "My Fans",
    icon: PeopleAltOutlinedIcon,
  },
  {
    id: 5,
    link: PATHS.MY_CONTENT,
    label: "My Content",
    icon: LibraryMusicOutlinedIcon,
  },
];

export const hqRoutes = [
  {
    id: 0,
    link: PATHS.HQ_DASHBOARD,
    label: "Dashboard",
    icon: HomeOutlined,
  },
  {
    id: 1,
    link: PATHS.CUSTOMERS,
    label: "Customers",
    icon: PeopleAltOutlinedIcon,
  },
  {
    id: 2,
    link: PATHS.AUTH_MONITOR,
    label: "Auth Monitor",
    icon: MonitorOutlinedIcon,
  },
  {
    id: 3,
    link: PATHS.TWILIO_MONITOR,
    label: "Twilio Monitor",
    icon: SmsOutlinedIcon,
  },
  {
    id: 4,
    link: PATHS.MANAGE,
    label: "Settings",
    icon: SettingsIcon,
  },
];